import { Component, OnInit } from '@angular/core';
import { NumFormatSchema } from '@gspwidget/util';

@Component({
  selector: 'lib-num-format-modal',
  templateUrl: './num-format-modal.component.html',
  styleUrls: ['./num-format-modal.component.scss']
})
export class NumFormatModalComponent implements OnInit {

  schema = new NumFormatSchema()

  constructor() { }

  ngOnInit() {
    if (!this.schema) this.schema = new NumFormatSchema()
  }

}
